/* ---- LeMobile: champ code promo panier (drawer + page) ----
   Applique un code via POST /cart/update.js avec { discount }.
   Met à jour les sections totals/discounts sans reload.
*/
(function () {
  function setMessage(field, text, type) {
    var msg = field.querySelector('[data-lm-discount-message]');
    if (!msg) return;
    msg.textContent = text || '';
    msg.classList.remove('lm-discount-field__message--error', 'lm-discount-field__message--success');
    if (type === 'error') msg.classList.add('lm-discount-field__message--error');
    if (type === 'success') msg.classList.add('lm-discount-field__message--success');
  }

  function setLoading(field, isLoading) {
    var btn = field.querySelector('[data-lm-discount-apply]');
    var input = field.querySelector('[data-lm-discount-input]');
    if (btn) {
      btn.disabled = isLoading;
      btn.classList.toggle('lm-loading', isLoading);
    }
    if (input) input.disabled = isLoading;
  }

  function currentDiscountCodes() {
    // Preserve any discount codes already applied (cart.discount_codes via window if present)
    if (window.lmCartDiscountCodes && Array.isArray(window.lmCartDiscountCodes)) {
      return window.lmCartDiscountCodes.slice();
    }
    return [];
  }

  function refreshCartSections() {
    var sectionIds = [];
    var mainItems = document.getElementById('main-cart-items');
    var mainFooter = document.getElementById('main-cart-footer');
    var drawerItems = document.getElementById('CartDrawer-CartItems');

    if (mainItems && mainItems.dataset.id) sectionIds.push(mainItems.dataset.id);
    if (mainFooter && mainFooter.dataset.id) sectionIds.push(mainFooter.dataset.id);
    if (drawerItems) sectionIds.push('cart-drawer');
    sectionIds.push('cart-icon-bubble');

    if (!sectionIds.length) return Promise.resolve();

    return fetch(window.routes.cart_url + '?section_id=' + sectionIds[0])
      .then(function () {
        // Fallback simple approach: reload relevant fragments individually
        var requests = sectionIds.map(function (id) {
          return fetch(window.routes.cart_url + '?section_id=' + id)
            .then(function (r) { return r.text(); })
            .then(function (html) { return { id: id, html: html }; });
        });
        return Promise.all(requests);
      })
      .then(function (results) {
        results.forEach(function (res) {
          var parsed = new DOMParser().parseFromString(res.html, 'text/html');

          if (res.id === 'cart-drawer') {
            var newDrawerItems = parsed.querySelector('#CartDrawer-CartItems');
            var newDrawerFooter = parsed.querySelector('.cart-drawer__footer');
            var curDrawerItems = document.getElementById('CartDrawer-CartItems');
            var curDrawerFooter = document.querySelector('.cart-drawer__footer');
            if (newDrawerItems && curDrawerItems) curDrawerItems.innerHTML = newDrawerItems.innerHTML;
            if (newDrawerFooter && curDrawerFooter) curDrawerFooter.replaceWith(newDrawerFooter);
            return;
          }

          if (res.id === 'cart-icon-bubble') {
            var newBubble = parsed.querySelector('.shopify-section');
            var curBubble = document.querySelector('#shopify-section-cart-icon-bubble') || document.querySelector('.shopify-section[id*="cart-icon-bubble"]');
            if (newBubble && curBubble) curBubble.innerHTML = newBubble.innerHTML;
            return;
          }

          var newJs = parsed.querySelector('.js-contents');
          var curContainer = document.getElementById(res.id);
          if (newJs && curContainer) {
            var curJs = curContainer.querySelector('.js-contents');
            if (curJs) curJs.innerHTML = newJs.innerHTML;
          }
        });
      })
      .catch(function () {});
  }

  function applyDiscount(field) {
    var input = field.querySelector('[data-lm-discount-input]');
    var code = (input.value || '').trim();
    if (!code) {
      setMessage(field, 'Entrez un code promo.', 'error');
      input.focus();
      return;
    }

    setLoading(field, true);
    setMessage(field, '', null);

    var codes = currentDiscountCodes();
    if (codes.indexOf(code) === -1) codes.push(code);

    fetch(window.routes.cart_update_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') }),
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        var cart = res.data;
        var applied = (cart.discount_codes || []).filter(function (d) { return d.applicable; });
        var matched = (cart.discount_codes || []).find(function (d) {
          return d.code && d.code.toLowerCase() === code.toLowerCase();
        });

        window.lmCartDiscountCodes = (cart.discount_codes || []).map(function (d) { return d.code; });

        if (!res.ok) {
          setMessage(field, "Ce code n'est pas valide.", 'error');
          setLoading(field, false);
          return;
        }

        if (matched && matched.applicable === false) {
          setMessage(field, "Ce code n'est pas applicable à ce panier.", 'error');
          setLoading(field, false);
          return;
        }

        if (!matched) {
          setMessage(field, "Ce code n'existe pas ou a expiré.", 'error');
          setLoading(field, false);
          return;
        }

        setMessage(field, 'Code « ' + code + ' » appliqué !', 'success');
        input.value = '';

        refreshCartSections().finally(function () {
          setLoading(field, false);
          if (window.lmToast) {
            window.lmToast({ title: 'Code promo appliqué', sub: code });
          }
        });
      })
      .catch(function () {
        setMessage(field, 'Erreur réseau, réessayez.', 'error');
        setLoading(field, false);
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lm-discount-apply]');
    if (!btn) return;
    var field = btn.closest('[data-lm-discount-field]');
    if (field) applyDiscount(field);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('[data-lm-discount-input]');
    if (!input) return;
    e.preventDefault();
    var field = input.closest('[data-lm-discount-field]');
    if (field) applyDiscount(field);
  });
})();
